import messages from '../../statics/messages.json';
import receiveContext from '../../context/ReceiveContext';
import { useState, useEffect } from 'react';
import usePresence from '../../hooks/usePresence';
import countriesData from '../../statics/countries.json';
import shipmentData from '../../statics/shipmentsData.json';
import statuses from '../../statics/status.json';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import * as XLSX from 'xlsx';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';

import { POPartsData, savePOComment, SearchPOData, SearchVendorData, saveLineStatus, syncPO } from '../../context/CommonContex';
import HoverPO from '../HoverPO';
import Hover from '../Hover';
import { Link } from 'react-router-dom';
import ColumnVisibilityModal from '../Common/ColumnVisibilityModal';
import PORefresh from './PORefresh';

import editIcon from '../../statics/images/pencil.png'
import filterIcon from '../../statics/images/filter.png'
import excelIcon from '../../statics/images/excel.png'

// Line Tag Tags with colors
const LINE_TAG_TAGS = [
    { label: 'Hot', color: '#E73030' },
    { label: 'Cable', color: '#6BAEFA' },
    { label: 'Connector', color: '#6BAEFA' },
    { label: 'Consumable', color: '#6BAEFA' },
    { label: 'COTS', color: '#6BAEFA' },
    { label: 'CSM', color: '#D373A8' },
    { label: 'Tools', color: '#F7AC21' },
    { label: 'Equipment', color: '#F7AC21' }
];

// Line Status Tags with colors
const LINE_STATUS_TAGS = [
    { label: 'Ordered', color: '#4AB2D5' },
    { label: 'Out for Delivery', color: '#37E292' },
    { label: 'Delivered', color: '#2D895F' },
    { label: 'Testing', color: '#84E6F8' },
    { label: 'Quality Hold', color: '#EB4F4F' },
    { label: 'Received', color: '#6FB169' }
];

const PO_VALIDATION_PRESENCE_PAGE = 'po-order-validation';

const PoOrderValidation = () => {
    const { productionDetailsFeatch, VendorFeatch, getPOValidationData, updatePOReview, updatePOAccept, updatePOArchive } = receiveContext();
    const [productionData, setProductionData] = useState([]);
    const [commentsMap, setCommentsMap] = useState({});
    const presence = usePresence(PO_VALIDATION_PRESENCE_PAGE, {
        onRemoteSave: (evt) => {
            if (!evt || evt.kind !== 'comment' || !evt.poLineId || evt.quoteId || !evt.value) return;
            const commentToStore = evt.value;
            setCommentsMap((prev) => {
                const current = prev[evt.poLineId] || [];
                const filtered = current.filter((c) => String(c?.id) !== String(commentToStore.id));
                return { ...prev, [evt.poLineId]: [...filtered, commentToStore] };
            });
        },
    });

    const handleAddComment = (lineId, newComment, status = 'pending') => {
        const currentUser = localStorage.getItem('userEmail') || localStorage.getItem('userName') || 'Current User';
        const commentToStore = newComment && typeof newComment === 'object'
            ? newComment
            : {
                id: Date.now(),
                comment: typeof newComment === 'string' ? newComment : '',
                lastEditedBy: currentUser,
                dateStr: new Date().toLocaleDateString(),
                timeStr: new Date().toLocaleTimeString(),
                resolved: false,
                status,
            };
        setCommentsMap((prev) => {
            const current = prev[lineId] || [];
            const filtered = current.filter((c) => String(c?.id) !== String(commentToStore.id));
            return { ...prev, [lineId]: [...filtered, commentToStore] };
        });
        const line = (Array.isArray(productionData) ? productionData : [])
            .find((row) => String(row?.id) === String(lineId));
        presence.broadcastSave({
            kind: 'comment',
            poLineId: String(lineId),
            lineId: String(lineId),
            orderNumber: line?.po?.ponum || '',
            customerName: line?.po?.vendorName || '',
            value: commentToStore,
        });
    };

    const [totalRecords, setTotalRecords] = useState(0);
    const [overallTotalRecords, setOverallTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(999999); // Default to "All"
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [statusFilter, setStatusFilter] = useState('Open');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
    const [sortingRequired, setSortRequired] = useState(false);
    const [priorityMap, setPriorityMap] = useState({});
    const [daysFilter, setDaysFilter] = useState(0);
    const [useEffectprcPart, setUseEffectPrcPart] = useState('');
    const [prcPart, setPrcPart] = useState([]);
    const [prcPartValue, setPrcPartValue] = useState('');

    const [useEffectPO, setUseEffectPO] = useState('');
    const [PO, setPO] = useState([]);
    const [POValue, setPOValue] = useState('');

    const [useEffectVendor, setUseEffectVendor] = useState('');
    const [Vendor, setVendor] = useState([]);
    const [VendorValue, setVendorValue] = useState('');

    const [POLinesData, setPoLinesData] = useState(true);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    // Client-side filter state (filter panel fields not sent to API)
    const [filterAssignedOwner, setFilterAssignedOwner] = useState('');
    const [filterLineNo, setFilterLineNo] = useState('');
    const [filterQty, setFilterQty] = useState('');
    const [filterVendorPart, setFilterVendorPart] = useState('');
    const [filterLineTag, setFilterLineTag] = useState('');
    const [filterPOComment, setFilterPOComment] = useState('');
    const [filterNotes, setFilterNotes] = useState('');
    const [filterLineStatus, setFilterLineStatus] = useState('');

    // Refresh state
    const [lastRefreshData, setLastRefreshData] = useState(null);
    const [isRefreshing, setIsRefreshing] = useState(false);

    const [exports, setExport] = useState(false);
    const [exportsClicked, setExportClicked] = useState('');

    const [maxAllSelect, setMaxAllSelect] = useState(false);

    // State for new purchase orders
    const [newPurchaseOrdersData, setNewPurchaseOrdersData] = useState([]);

    // State for archived PO lines (stored as Set of PO line IDs for filtering)
    const [archivedPOLineIds, setArchivedPOLineIds] = useState(() => {
        const savedArchived = localStorage.getItem('archivedPOLineIds');
        return savedArchived ? new Set(JSON.parse(savedArchived)) : new Set();
    });

    // State for archived PO lines data (stored as array of full PO line objects)
    const [archivedPOLinesData, setArchivedPOLinesData] = useState(() => {
        const savedArchivedData = localStorage.getItem('archivedPOLinesData');
        return savedArchivedData ? JSON.parse(savedArchivedData) : [];
    });

    // PO Verification state
    const [reviewToggles, setReviewToggles] = useState(() => {
        const saved = localStorage.getItem('poReviewToggles');
        return saved ? JSON.parse(saved) : {};
    });
    const [confirmCheckboxes, setConfirmCheckboxes] = useState(() => {
        const saved = localStorage.getItem('poConfirmCheckboxes');
        return saved ? JSON.parse(saved) : {};
    });

    // Line Tag state management
    const [lineTagSelections, setLineTagSelections] = useState({});
    const [submittedLineTags, setSubmittedLineTags] = useState({});
    const [lineTagsToDeselect, setLineTagsToDeselect] = useState({});
    const [lineTagDropdownOpenId, setLineTagDropdownOpenId] = useState(null);
    const [lineTagDropdownPosition, setLineTagDropdownPosition] = useState(null);

    // Line Status state management
    const [lineStatusSelections, setLineStatusSelections] = useState({});
    const [submittedLineStatuses, setSubmittedLineStatuses] = useState({});
    const [lineStatusTagsToDeselect, setLineStatusTagsToDeselect] = useState({});
    const [lineStatusDropdownOpenId, setLineStatusDropdownOpenId] = useState(null);
    const [lineStatusDropdownPosition, setLineStatusDropdownPosition] = useState(null);

    // Part# column — compact link menu (UI only; actions wired later)
    const [partLinkMenuLineId, setPartLinkMenuLineId] = useState(null);

    // Column visibility state
    const [showColumnModal, setShowColumnModal] = useState(false);
    const [columnVisibility, setColumnVisibility] = useState(() => {
        const saved = localStorage.getItem('poOrderValidation_columnVisibility');
        return saved ? JSON.parse(saved) : {};
    });

    // Docs column - folder links per PO line (localStorage only)
    const [docsLinks, setDocsLinks] = useState(() => {
        const saved = localStorage.getItem('poOrderValidation_docsLinks');
        return saved ? JSON.parse(saved) : {};
    });
    const [showDocsModal, setShowDocsModal] = useState(false);
    const [selectedLineForDocs, setSelectedLineForDocs] = useState(null);
    const [newDocsLinkUrl, setNewDocsLinkUrl] = useState('');

    // Define columns for PO Order Validation
    const poOrderValidationColumns = [
        { key: 'assigned_owner', label: 'Assigned / Owner' },
        { key: 'po_verification', label: 'PO Verification' },
        { key: 'po_label', label: messages.po_label },
        { key: 'line_no', label: messages.line_no },
        { key: 'vendor_label', label: messages.vendor_label },
        { key: 'part', label: 'Part#' },
        { key: 'qty', label: 'QTY' },
        { key: 'vendor_part', label: 'Vendor Part#' },
        { key: 'dock_date', label: 'Dock Date' },
        { key: 'line_tag', label: 'Line Tag' },
        { key: 'comments_po', label: messages.comments_po_label },
        { key: 'comments', label: messages.comments_label },
        { key: 'line_status', label: 'Line Status' },
        { key: 'docs', label: 'Docs' },
        { key: 'archive', label: 'Archive' }
    ];

    const handleColumnVisibilityChange = (newVisibility) => {
        setColumnVisibility(newVisibility);
        localStorage.setItem('poOrderValidation_columnVisibility', JSON.stringify(newVisibility));
    };

    const isColumnVisible = (columnKey) => {
        return columnVisibility[columnKey] !== false; // Default to visible if not set
    };

    const [formData, setFormData] = useState({
        comment: "",
        flowName: "Order",
        status: "",
        poLineId: "",
        poStatus:""
    });



    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        debugger
        try {
            formData.id = null;
            formData.flowName = "Purchase Order";
            formData.lastEditedBy = "Test";
            formData.poLineId = updatePopUp.id;
            const comment = await savePOComment(formData);
            const savedLine = updatePopUp && typeof updatePopUp === 'object' ? updatePopUp : null;
            const savedLineId = formData.poLineId || savedLine?.id;
            if (savedLineId) {
                presence.broadcastSave({
                    kind: 'comment',
                    poLineId: String(savedLineId),
                    lineId: String(savedLineId),
                    orderNumber: savedLine?.po?.ponum || '',
                    customerName: savedLine?.po?.vendorName || '',
                    value: {
                        id: comment?.id || Date.now(),
                        comment: formData.comment,
                        lastEditedBy: localStorage.getItem('userEmail') || localStorage.getItem('userName') || 'Current User',
                        dateStr: new Date().toLocaleDateString(),
                        timeStr: new Date().toLocaleTimeString(),
                        status: formData.status || 'pending',
                        resolved: false,
                    },
                });
            }
            setCurrentPage(1);
            fetchProduction((currentPage - 1) * itemsPerPage, itemsPerPage, searchTerm)
            handleClose();
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [updatePopUp, setUpdatePopUp] = useState('');
    const [clear,setClear] = useState(false);
    const fetchProduction = async (index, maxRecords, search, status) => {
        debugger
         
        setLoading(true);
        if (status === undefined)
            status = statusFilter;

        if (new Date(startDate) > new Date(endDate)) {
            alert('Start date can\'t be greater than End date.');
            return;
        } else if (endDate && !startDate) {
            alert('Select Start Date.');
            return;
        }

        const production = await getPOValidationData(index, maxRecords, searchTerm, status, daysFilter, sortConfig.key, sortConfig.direction, POValue, prcPartValue, VendorValue, startDate, endDate, exports);
        
        if (maxAllSelect) {
            // Filter only new orders for maxAllSelect
            const newOrders = production.production.filter(line => line.po?.newOrder === true);
            setProductionData(newOrders);
            setTotalRecords(newOrders.length);
            if (production.totalRecords > 0) {
                setOverallTotalRecords((prev) => Math.max(prev, production.totalRecords));
            }
        }
        else if (exports) {
            // Filter only new orders for export
            const newOrders = production.production.filter(line => line.po?.newOrder === true);
            const xslData = newOrders;

            const exportData = xslData.map((line, lineIndex) => ({
                PONumber: line.po.ponum,
                LineNum: line.linenum,
                VendorName: line.po.vendorName,
                Part: line.prcpart.substring(3) || '',
                DueDate: line.duedate ? line.duedate : '',
                Status: line.status,
            }));

            // Create a worksheet
            const ws = XLSX.utils.json_to_sheet(exportData);

            // Create a workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Data');

            // Export the workbook
            XLSX.writeFile(wb, 'po_export.xlsx');
            setExport(false);
        } else if (production.production) {
            // Filter only new orders
            const newOrders = production.production.filter(line => line.po?.newOrder === true);
            
            // Initialize review toggles and confirm checkboxes based on response data
            if (Array.isArray(newOrders) && newOrders.length > 0) {
                const newReviewToggles = {};
                const newConfirmCheckboxes = {};

                newOrders.forEach(line => {
                    // Set review toggle based on poReviewed value from backend (if available)
                    // Otherwise, keep existing localStorage value
                    if (line.po?.poReviewed !== undefined) {
                        newReviewToggles[line.id] = line.po.poReviewed === true;
                    } else {
                        // Keep existing value from state if backend doesn't provide it
                        newReviewToggles[line.id] = reviewToggles[line.id] || false;
                    }

                    // Set confirm checkbox based on acceptedPO value from backend (if available)
                    // Otherwise, keep existing localStorage value
                    if (line.po?.acceptedPO !== undefined) {
                        newConfirmCheckboxes[line.id] = line.po.acceptedPO === true;
                    } else {
                        // Keep existing value from state if backend doesn't provide it
                        newConfirmCheckboxes[line.id] = confirmCheckboxes[line.id] || false;
                    }
                });

                // Update states with initialized values
                setReviewToggles(prev => ({ ...prev, ...newReviewToggles }));
                setConfirmCheckboxes(prev => ({ ...prev, ...newConfirmCheckboxes }));
            }

            const lineStatusMap = {};
            if (Array.isArray(newOrders) && newOrders.length > 0) {
                newOrders.forEach((line) => {
                    if (line.lineItemStatus) {
                        try {
                            const parsedStatus = typeof line.lineItemStatus === 'string'
                                ? JSON.parse(line.lineItemStatus)
                                : line.lineItemStatus;
                            if (Array.isArray(parsedStatus)) {
                                lineStatusMap[line.id] = parsedStatus;
                            }
                        } catch (e) {
                            console.error(`Error parsing lineItemStatus for line ${line.id}:`, e);
                        }
                    }
                });
            }
            if (Object.keys(lineStatusMap).length > 0) {
                setSubmittedLineStatuses(lineStatusMap);
            }
            
            setNewPurchaseOrdersData(newOrders);
            // Set only new orders to productionData
            setProductionData(newOrders);
            setTotalRecords(newOrders.length);
            if (production.totalRecords > 0) {
                setOverallTotalRecords((prev) => Math.max(prev, production.totalRecords));
            }
        }
        setLoading(false);

    };

    useEffect(() => {
        fetchProduction((currentPage - 1) * itemsPerPage, itemsPerPage, statusFilter);
    }, [currentPage, itemsPerPage, statusFilter, daysFilter, sortConfig, POLinesData, exportsClicked]);


    useEffect(() => {
        localStorage.setItem('archivedPOLineIds', JSON.stringify(Array.from(archivedPOLineIds)));
    }, [archivedPOLineIds]);

    useEffect(() => {
        localStorage.setItem('archivedPOLinesData', JSON.stringify(archivedPOLinesData));
    }, [archivedPOLinesData]);

    // Save PO Verification state to localStorage
    useEffect(() => {
        localStorage.setItem('poReviewToggles', JSON.stringify(reviewToggles));
    }, [reviewToggles]);

    useEffect(() => {
        localStorage.setItem('poConfirmCheckboxes', JSON.stringify(confirmCheckboxes));
    }, [confirmCheckboxes]);

    useEffect(() => {
    if (clear) {
            setSearchTerm('');
            setStartDate('');
            setEndDate('');
            setStatusFilter('Open');
            setDaysFilter(0);
            setSortConfig({
                key:null,
                direction:null
            });
            setPoLinesData(true);
            setPOValue('');
            setPrcPartValue('');
            setPOValue('');
            setVendorValue('');
            setFilterAssignedOwner('');
            setFilterLineNo('');
            setFilterQty('');
            setFilterVendorPart('');
            setFilterLineTag('');
            setFilterPOComment('');
            setFilterNotes('');
            setFilterLineStatus('');
            setExport(false);
            setClear(false);
            fetchProduction((currentPage - 1) * itemsPerPage, itemsPerPage, statusFilter);
    }
}, [clear]);

    // Client-side filter: match line against filter panel values (non-API filters)
    const matchesClientFilters = (line) => {
        const assignedOwner = (line.po?.assignedTo ?? line.po?.owner ?? line.assigned_owner ?? '').toString();
        if (filterAssignedOwner.trim() && !assignedOwner.toLowerCase().includes(filterAssignedOwner.trim().toLowerCase())) return false;
        if (filterLineNo.trim() && !String(line.linenum ?? '').toLowerCase().includes(filterLineNo.trim().toLowerCase())) return false;
        if (filterQty.trim() && !String(line.orderqty ?? '').toLowerCase().includes(filterQty.trim().toLowerCase())) return false;
        if (filterVendorPart.trim() && !String(line.cross_part ?? '').toLowerCase().includes(filterVendorPart.trim().toLowerCase())) return false;
        const lineTagLabels = (submittedLineTags[line.id] || []).map(t => t.label).join(' ');
        if (filterLineTag.trim() && !lineTagLabels.toLowerCase().includes(filterLineTag.trim().toLowerCase())) return false;
        const poComment = (line.po?.comment ?? '').toString();
        if (filterPOComment.trim() && !poComment.toLowerCase().includes(filterPOComment.trim().toLowerCase())) return false;
        const lastNote = line.comment?.length ? (line.comment[line.comment.length - 1]?.comment ?? '') : '';
        if (filterNotes.trim() && !lastNote.toLowerCase().includes(filterNotes.trim().toLowerCase())) return false;
        const lineStatusLabels = (submittedLineStatuses[line.id] || []).map(t => t.label).join(' ');
        if (filterLineStatus.trim() && !lineStatusLabels.toLowerCase().includes(filterLineStatus.trim().toLowerCase())) return false;
        return true;
    };

    const filteredProductionData = productionData.filter(line => !archivedPOLineIds.has(line.id)).filter(matchesClientFilters);
    const filteredNewOrdersData = newPurchaseOrdersData.filter(line => !archivedPOLineIds.has(line.id)).filter(matchesClientFilters);

    const totalPages = Math.ceil(totalRecords / itemsPerPage);

    const hasPaginatedRecords = filteredProductionData.length > 0;
    const startRecord = hasPaginatedRecords ? (itemsPerPage >= 999999 ? 1 : (currentPage - 1) * itemsPerPage + 1) : 0;
    const endRecord = hasPaginatedRecords ? startRecord + filteredProductionData.length - 1 : 0;
    const displayTotalRecords = overallTotalRecords > 0 ? overallTotalRecords : totalRecords;

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages)
            return;
        setCurrentPage(page);
    };

    const getVendorName = (id) => {
        const ven = vendors.find((ven) => ven.vennum == id);
        return ven ? ven.name : 'N/A';
    };


    const handleSort = (key) => {
        debugger
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
        setSortRequired(true);

    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return null;
        return sortConfig.direction === 'ascending' ? '▲' : '▼';
    };


    const handlePriorityChange = (lineId, newPriority) => {
        setPriorityMap(prev => ({
            ...prev,
            [lineId]: newPriority
        }));
    };

    // Refresh function - sync PO + reload current table data
    const handleRefreshPO = async () => {
        const userEmail = localStorage.getItem('userEmail');
        if (!userEmail) {
            alert('User email not found');
            throw new Error('User email not found');
        }

        setIsRefreshing(true);
        try {
            await syncPO({ userName: userEmail });
            await fetchProduction((currentPage - 1) * itemsPerPage, itemsPerPage, searchTerm, statusFilter);
            setLastRefreshData({
                timestamp: new Date(),
                user: userEmail,
                success: true
            });
        } catch (error) {
            console.error('PO refresh failed:', error);
            setLastRefreshData({
                timestamp: new Date(),
                user: userEmail,
                success: false,
                error: error.message
            });
            throw error;
        } finally {
            setIsRefreshing(false);
        }
    };

    // Persist docs links to localStorage
    useEffect(() => {
        localStorage.setItem('poOrderValidation_docsLinks', JSON.stringify(docsLinks));
    }, [docsLinks]);

    // Docs column - add/open folder links (localStorage only)
    const handleDocsClick = (line) => {
        setSelectedLineForDocs(line);
        setShowDocsModal(true);
        setNewDocsLinkUrl('');
    };

    const handleAddDocsLink = () => {
        if (!newDocsLinkUrl.trim()) {
            alert('Please enter a URL');
            return;
        }
        try {
            new URL(newDocsLinkUrl.trim());
        } catch {
            alert('Please enter a valid URL (include http:// or https://)');
            return;
        }
        const newLink = { id: Date.now(), url: newDocsLinkUrl.trim(), dateAdded: new Date().toLocaleDateString() };
        setDocsLinks(prev => ({
            ...prev,
            [selectedLineForDocs.id]: [...(prev[selectedLineForDocs.id] || []), newLink]
        }));
        setNewDocsLinkUrl('');
    };

    const handleDeleteDocsLink = (lineId, linkId) => {
        setDocsLinks(prev => {
            const current = prev[lineId] || [];
            return { ...prev, [lineId]: current.filter(link => link.id !== linkId) };
        });
    };

    const handleCloseDocsModal = () => {
        setShowDocsModal(false);
        setSelectedLineForDocs(null);
        setNewDocsLinkUrl('');
    };

    // Archive functions
    const handleArchiveOrder = async (line) => {
        if (window.confirm(`Are you sure you want to archive PO ${line.po?.ponum} - Line ${line.linenum}?`)) {
            try {
                // Optimistic update - add to archived state immediately
                setArchivedPOLineIds(prev => {
                    const newSet = new Set(prev);
                    newSet.add(line.id);
                    return newSet;
                });

                // Store full PO line data for display in Archive page
                setArchivedPOLinesData(prev => {
                    // Check if this PO line is already archived
                    const existingIndex = prev.findIndex(archived => archived.id === line.id);
                    if (existingIndex === -1) {
                        // Add new archived PO line
                        return [...prev, line];
                    } else {
                        // Update existing archived PO line
                        const updated = [...prev];
                        updated[existingIndex] = line;
                        return updated;
                    }
                });

                // Call backend API to persist archive status
                const result = await updatePOArchive(line.po?.ponum, true);

                if (result.success) {
                    console.log('PO archived successfully:', result.message);
                } else {
                    console.error('Failed to archive PO:', result.message);
                    // Revert optimistic update on failure
                    setArchivedPOLineIds(prev => {
                        const newSet = new Set(prev);
                        newSet.delete(line.id);
                        return newSet;
                    });
                    setArchivedPOLinesData(prev => prev.filter(archived => archived.id !== line.id));
                    alert('Failed to archive PO: ' + result.message);
                }
            } catch (error) {
                console.error('Error archiving PO:', error);
                // Revert optimistic update on error
                setArchivedPOLineIds(prev => {
                    const newSet = new Set(prev);
                    newSet.delete(line.id);
                    return newSet;
                });
                setArchivedPOLinesData(prev => prev.filter(archived => archived.id !== line.id));
                alert('Error archiving PO. Please try again.');
            }
        }
    };

    // Handler functions for PO Verification
    const handleReviewToggle = async (lineId, poNum, newValue) => {
        try {
            // Optimistic update
            setReviewToggles(prev => ({
                ...prev,
                [lineId]: newValue
            }));

            // Call backend API
            const result = await updatePOReview(poNum, newValue);
            
            if (result.success) {
                // Success - state already updated optimistically
            } else {
                // Revert optimistic update if API fails
                setReviewToggles(prev => ({
                    ...prev,
                    [lineId]: !newValue
                }));
                alert(result.message || 'Failed to update review status');
            }
        } catch (error) {
            console.error('Error updating review:', error);
            // Revert optimistic update
            setReviewToggles(prev => ({
                ...prev,
                [lineId]: !newValue
            }));
            alert('Error updating review status');
        }
    };

    const handleConfirmToggle = async (lineId, poNum, newValue) => {
        // Validation: PO must be reviewed before confirming
        if (newValue && !reviewToggles[lineId]) {
            alert('PO must be reviewed first before confirming (Confirm & Move). Please click the Review checkbox first.');
            return;
        }

        try {
            // Optimistic update
            setConfirmCheckboxes(prev => ({
                ...prev,
                [lineId]: newValue
            }));

            // Call backend API
            const result = await updatePOAccept(poNum, newValue);
            
            if (result.success) {
                // Success - state already updated optimistically
            } else {
                // Revert optimistic update if API fails
                setConfirmCheckboxes(prev => ({
                    ...prev,
                    [lineId]: !newValue
                }));
                alert(result.message || 'Failed to update accept status');
            }
        } catch (error) {
            console.error('Error updating accept:', error);
            // Revert optimistic update
            setConfirmCheckboxes(prev => ({
                ...prev,
                [lineId]: !newValue
            }));
            alert('Error updating accept status');
        }
    };

    // Line Tag handler functions (only one dropdown open at a time)
    const toggleLineTagDropdown = (lineId, event) => {
        if (lineTagDropdownOpenId === lineId) {
            setLineTagDropdownOpenId(null);
            setLineTagDropdownPosition(null);
            return;
        }
        const rect = event.currentTarget.getBoundingClientRect();
        const parentRect = event.currentTarget.closest('.line-tag-dropdown-container')?.getBoundingClientRect() || rect;
        setLineTagDropdownOpenId(lineId);
        setLineTagDropdownPosition({
            top: rect.bottom - parentRect.top,
            left: rect.left - parentRect.left,
            width: rect.width
        });
    };

    const handleLineTagToggle = (lineId, tag) => {
        setLineTagSelections(prev => {
            const currentSelections = prev[lineId] || [];
            const isSelected = currentSelections.some(selection => selection.label === tag.label);
            
            if (isSelected) {
                return {
                    ...prev,
                    [lineId]: currentSelections.filter(selection => selection.label !== tag.label)
                };
            } else {
                return {
                    ...prev,
                    [lineId]: [...currentSelections, tag]
                };
            }
        });
    };

    const handleLineTagDeselect = (lineId, tag) => {
        setLineTagsToDeselect(prev => {
            const currentDeselections = prev[lineId] || [];
            const isMarked = currentDeselections.some(t => t.label === tag.label);
            
            if (isMarked) {
                return {
                    ...prev,
                    [lineId]: currentDeselections.filter(t => t.label !== tag.label)
                };
            } else {
                return {
                    ...prev,
                    [lineId]: [...currentDeselections, tag]
                };
            }
        });
    };

    const hasLineTagChangesToSubmit = (lineId) => {
        const currentSelections = lineTagSelections[lineId] || [];
        const submittedSelections = submittedLineTags[lineId] || [];
        const tagsToRemove = lineTagsToDeselect[lineId] || [];
        
        return currentSelections.length > 0 || tagsToRemove.length > 0;
    };

    const handleLineTagSubmit = (lineId) => {
        const currentSelections = lineTagSelections[lineId] || [];
        const submittedSelections = submittedLineTags[lineId] || [];
        const tagsToRemove = lineTagsToDeselect[lineId] || [];
        
        // Calculate final selections
        const finalSelections = [
            ...currentSelections,
            ...submittedSelections.filter(
                tag => !tagsToRemove.some(removeTag => removeTag.label === tag.label)
            )
        ].filter((tag, index, array) =>
            array.findIndex(t => t.label === tag.label) === index
        );
        
        // Update submitted tags
        setSubmittedLineTags(prev => ({
            ...prev,
            [lineId]: finalSelections
        }));
        
        // Clear pending selections and deselections
        setLineTagSelections(prev => {
            const newState = { ...prev };
            delete newState[lineId];
            return newState;
        });
        
        setLineTagsToDeselect(prev => {
            const newState = { ...prev };
            delete newState[lineId];
            return newState;
        });
    };

    const lineHasActiveSavedReceived = (lineId) => {
        const submitted = submittedLineStatuses[lineId] || [];
        const toRemove = lineStatusTagsToDeselect[lineId] || [];
        return submitted.some(
            (t) =>
                String(t.label || '').trim().toLowerCase() === 'received' &&
                !toRemove.some((r) => String(r.label || '').trim().toLowerCase() === 'received')
        );
    };

    // Line Status handler functions (only one dropdown open at a time)
    const toggleLineStatusDropdown = (lineId, event) => {
        if (lineStatusDropdownOpenId === lineId) {
            setLineStatusDropdownOpenId(null);
            setLineStatusDropdownPosition(null);
            return;
        }
        const rect = event.currentTarget.getBoundingClientRect();
        const parentRect = event.currentTarget.closest('.line-status-dropdown-container')?.getBoundingClientRect() || rect;
        setLineStatusDropdownOpenId(lineId);
        setLineStatusDropdownPosition({
            top: rect.bottom - parentRect.top,
            left: rect.left - parentRect.left,
            width: rect.width
        });
    };

    const handleLineStatusToggle = (lineId, tag) => {
        setLineStatusSelections(prev => {
            const currentSelections = prev[lineId] || [];
            const isSelected = currentSelections.some(selection => selection.label === tag.label);
            
            if (isSelected) {
                return {
                    ...prev,
                    [lineId]: currentSelections.filter(selection => selection.label !== tag.label)
                };
            } else {
                return {
                    ...prev,
                    [lineId]: [...currentSelections, tag]
                };
            }
        });
    };

    const handleLineStatusDeselect = (lineId, tag) => {
        setLineStatusTagsToDeselect(prev => {
            const currentDeselections = prev[lineId] || [];
            const isMarked = currentDeselections.some(t => t.label === tag.label);
            
            if (isMarked) {
                return {
                    ...prev,
                    [lineId]: currentDeselections.filter(t => t.label !== tag.label)
                };
            } else {
                return {
                    ...prev,
                    [lineId]: [...currentDeselections, tag]
                };
            }
        });
    };

    const hasLineStatusChangesToSubmit = (lineId) => {
        const currentSelections = lineStatusSelections[lineId] || [];
        const submittedSelections = submittedLineStatuses[lineId] || [];
        const tagsToRemove = lineStatusTagsToDeselect[lineId] || [];
        
        return currentSelections.length > 0 || tagsToRemove.length > 0;
    };

    const handleLineStatusSubmit = async (lineId) => {
        const currentSelections = lineStatusSelections[lineId] || [];
        const submittedSelections = submittedLineStatuses[lineId] || [];
        const tagsToRemove = lineStatusTagsToDeselect[lineId] || [];
        
        // Calculate final selections
        const finalSelections = [
            ...currentSelections,
            ...submittedSelections.filter(
                tag => !tagsToRemove.some(removeTag => removeTag.label === tag.label)
            )
        ].filter((tag, index, array) =>
            array.findIndex(t => t.label === tag.label) === index
        );
        
        try {
            // Prepare data for API call
            const submitData = {
                lineId: lineId,
                status: JSON.stringify(finalSelections)
            };
            
            // Call API to save line status
            await saveLineStatus(submitData);
            
            // Update submitted tags
            setSubmittedLineStatuses(prev => ({
                ...prev,
                [lineId]: finalSelections
            }));
            
            // Clear pending selections and deselections
            setLineStatusSelections(prev => {
                const newState = { ...prev };
                delete newState[lineId];
                return newState;
            });
            
            setLineStatusTagsToDeselect(prev => {
                const newState = { ...prev };
                delete newState[lineId];
                return newState;
            });
        } catch (error) {
            console.error("Error submitting line status:", error);
            alert("Error submitting line status. Please try again.");
        }
    };

    // Close Line Tag dropdown on click outside (single open: close when click outside its container)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (lineTagDropdownOpenId != null) {
                const container = document.querySelector(`[data-line-tag-line-id="${CSS.escape(String(lineTagDropdownOpenId))}"]`);
                if (container && !container.contains(event.target)) {
                    setLineTagDropdownOpenId(null);
                    setLineTagDropdownPosition(null);
                }
            }
            if (lineStatusDropdownOpenId != null) {
                const container = document.querySelector(`[data-line-status-line-id="${CSS.escape(String(lineStatusDropdownOpenId))}"]`);
                if (container && !container.contains(event.target)) {
                    setLineStatusDropdownOpenId(null);
                    setLineStatusDropdownPosition(null);
                }
            }
            if (partLinkMenuLineId != null) {
                const container = document.querySelector(`[data-part-link-menu-line-id="${CSS.escape(String(partLinkMenuLineId))}"]`);
                if (container && !container.contains(event.target)) {
                    setPartLinkMenuLineId(null);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [lineTagDropdownOpenId, lineStatusDropdownOpenId, partLinkMenuLineId]);

    const partLinkMenuItems = [
        { key: 'inventory', label: 'Inventory', iconClass: 'fa fa-cubes', color: '#2d895f' },
        { key: 'waterfall', label: 'Waterfall', iconClass: 'fa fa-line-chart', color: '#f7ac21' },
        { key: 'purchase', label: 'Purchase', iconClass: 'fa fa-shopping-cart', color: '#4ab2d5' },
        { key: 'sales', label: 'Sales', iconClass: 'fa fa-bar-chart', color: '#e73030' },
    ];

    const renderPartNumberCell = (line) => {
        const partText = line.prcpart.substring(3) || 'N/A';
        const isOpen = partLinkMenuLineId === line.id;
        return (
            <td className="text-center" style={{ verticalAlign: 'middle' }}>
                <div
                    className="d-inline-flex align-items-center justify-content-center gap-1 position-relative"
                    style={{ maxWidth: '100%' }}
                    data-part-link-menu-line-id={line.id}
                >
                    <span style={{ minWidth: 0 }}>{partText}</span>
                    <button
                        type="button"
                        aria-expanded={isOpen}
                        aria-haspopup="listbox"
                        title="Part links"
                        onClick={(e) => {
                            e.stopPropagation();
                            setPartLinkMenuLineId(isOpen ? null : line.id);
                        }}
                        style={{
                            flexShrink: 0,
                            width: 20,
                            height: 20,
                            padding: 0,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#fff',
                            border: '1px solid #0d6efd',
                            borderRadius: 3,
                            cursor: 'pointer',
                        }}
                    >
                        <i className="fa fa-link" style={{ fontSize: 10, color: '#0d6efd' }} aria-hidden="true" />
                    </button>
                    {isOpen && (
                        <ul
                            role="listbox"
                            className="m-0 p-0"
                            style={{
                                position: 'absolute',
                                top: '100%',
                                right: 0,
                                marginTop: 4,
                                minWidth: 188,
                                listStyle: 'none',
                                background: '#fff',
                                borderRadius: 8,
                                boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
                                zIndex: 1050,
                                textAlign: 'left',
                                paddingTop: 4,
                                paddingBottom: 4,
                            }}
                        >
                            {partLinkMenuItems.map((item) => (
                                <li key={item.key} role="none">
                                    <button
                                        type="button"
                                        role="option"
                                        className="w-100 border-0 bg-transparent d-flex align-items-center gap-2"
                                        style={{
                                            fontSize: 14,
                                            cursor: 'pointer',
                                            padding: '8px 14px',
                                            whiteSpace: 'nowrap',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#e7f1ff';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={() => setPartLinkMenuLineId(null)}
                                    >
                                        <i
                                            className={item.iconClass}
                                            style={{ color: item.color, width: 20, textAlign: 'center' }}
                                            aria-hidden="true"
                                        />
                                        <span>{item.label}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </td>
        );
    };

    const handleKeyDown = (event) => {
        // debugger;
        // if (event.key === 'Enter' || event.key === 'Backspace') {
        fetchProduction(0, 10);
        // }
    };

    // Row coloring not used - match Open PO's (no row background)
    const getRowStyle = (date) => {
        return {};
    };

    // Dock Date cell styling - match Open PO's exactly (cell-only colors, same palette)
    const getDueDateStyle = (dueDate) => {
        const today = new Date();
        const targetDate = new Date(dueDate);
        const timeDiff = targetDate - today;
        const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
        // Past due: Light red
        if (diffDays < 0) {
            return {
                backgroundColor: '#ffcccc',
                color: 'black',
                textAlign: 'center'
            };
        }
        // Day of dock date: Pale blue
        if (diffDays === 0) {
            return {
                backgroundColor: '#cce5ff',
                color: 'black',
                textAlign: 'center'
            };
        }
        // 2 days to dock date: Pale yellow
        if (diffDays === 2) {
            return {
                backgroundColor: '#fff9cc',
                color: 'black',
                textAlign: 'center'
            };
        }
        // Default: transparent
        return {
            backgroundColor: 'transparent',
            color: 'black',
            textAlign: 'center'
        };
    };

    const fetchData = async () => {
        debugger
        if (!useEffectprcPart || useEffectprcPart === '' || useEffectprcPart.length === 0) {
            setPrcPart([]);
            setPrcPartValue(useEffectprcPart);
            return;
        }
        const prcData = await POPartsData(useEffectprcPart, statusFilter, sortConfig.key, sortConfig.direction);
        debugger
        setPrcPart(prcData.production);
        setPrcPartValue(useEffectprcPart);
    };

    const fetchPOData = async () => {
        debugger
        if (!useEffectPO || useEffectPO === '' || useEffectPO.length === 0) {
            setPO([]);
            setPOValue(useEffectPO);
            return;
        }
        const prcData = await SearchPOData(useEffectPO, statusFilter, sortConfig.key, sortConfig.direction);
        debugger
        if (prcData != null) {
            setPO(prcData.content);
            setPOValue(useEffectPO);
        }

    };

    const fetchVendorData = async () => {
        debugger
        if (!useEffectVendor || useEffectVendor === '' || useEffectVendor.length === 0) {
            setVendor([]);
            setVendorValue(useEffectVendor);
            return;
        }
        const prcData = await SearchVendorData(useEffectVendor, statusFilter, sortConfig.key, sortConfig.direction);
        debugger
        if (prcData != null) {
            setVendor(prcData.content);
            setVendorValue(useEffectVendor);
        }
    };

    useEffect(() => {
        fetchData();

    }, [useEffectprcPart]);

    useEffect(() => {
        fetchPOData();

    }, [useEffectPO]);

    useEffect(() => {
        fetchVendorData();

    }, [useEffectVendor]);

    const [filterTabOpen, setFilterTab] = useState(false);

    // Log on page mount
    useEffect(() => {
        console.log('🚀 [PoOrderValidation] Page loaded - PO validation page initialized');
    }, []);

    return (
        <div className="box-body border b-white rounded-2">
            <div class="p-2 m-0 border-bottom row">
                <div class="col-12 d-flex justify-content-center align-items-center mb-3">
                    <div className="production-title">
                        <span className="production-text">{messages.po_order_validation_label}</span>
                    </div>
                </div>
                <div class="col-9 d-flex justify-content-start align-items-center gap-3">
                    <PORefresh
                        onRefresh={handleRefreshPO}
                        lastRefreshData={lastRefreshData}
                        isLoading={isRefreshing}
                        title="Purchase Orders"
                    />
                </div>
                <div class="col-3 d-flex justify-content-end align-items-center gap-3">
                    <Link to="/Highlights" className='btn btn-primary'>{messages.Highlights_label}</Link>
                    <button class="btn border-success d-flex align-items-center gap-2 px-3" onClick={() => { setFilterTab(filterTabOpen === true ? false : true) }} >
                        <img src={filterIcon} style={{ width: "16px", height: "16px" }} />
                        <span>Filter</span>
                    </button>
                    <button class="btn border-success d-flex align-items-center gap-2 px-3" onClick={() => { setExport(true); setExportClicked(exportsClicked ? false : true) }}>
                        <img src={excelIcon} style={{ width: "16px", height: "16px" }} />
                        <span>Export</span>
                    </button>
                </div>
            </div>
            {filterTabOpen ?
                <div className="row p-2 m-0" style={{ background: '#d3d3d333' }}>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>Assigned / Owner</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={filterAssignedOwner} onInput={(e) => setFilterAssignedOwner(e.target.value)} placeholder="" />
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>P.O#</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={POValue} onInput={(e) => setUseEffectPO(e.target.value)} />
                        {PO.length > 0 && (
                            <ul
                                style={{
                                    listStyleType: 'none',
                                    margin: '10px 0',
                                    padding: '0',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    position: 'absolute',
                                    background: 'white',
                                    top: '155px',
                                    zIndex: '10'
                                }}
                            >
                                {PO.map((item, index) => (
                                    <li
                                        key={index}
                                        style={{
                                            padding: '10px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                        }}
                                        onClick={() => {
                                            setPOValue(item.ponum);
                                            setPO([]);
                                        }}
                                    >
                                        {item.ponum}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>Line#</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={filterLineNo} onInput={(e) => setFilterLineNo(e.target.value)} />
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>Vendor</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={VendorValue} onInput={(e) => setUseEffectVendor(e.target.value)} />
                        {Vendor.length > 0 && (
                            <ul
                                style={{
                                    listStyleType: 'none',
                                    margin: '10px 0',
                                    padding: '0',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    position: 'absolute',
                                    background: 'white',
                                    top: '155px',
                                    zIndex: '10'
                                }}
                            >
                                {Vendor.map((item, index) => (
                                    <li
                                        key={index}
                                        style={{
                                            padding: '10px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                        }}
                                        onClick={() => {
                                            setVendorValue(item.name);
                                            setVendor([]);
                                        }}
                                    >
                                        {item.name}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>Part#</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={prcPartValue} onInput={(e) => setUseEffectPrcPart(e.target.value)} />
                        {prcPart.length > 0 && (
                            <ul
                                style={{
                                    listStyleType: 'none',
                                    margin: '10px 0',
                                    padding: '0',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    position: 'absolute',
                                    background: 'white',
                                    top: '200px',
                                    zIndex: '10'
                                }}
                            >
                                {prcPart.map((item, index) => (
                                    <li
                                        key={index}
                                        style={{
                                            padding: '10px',
                                            cursor: 'pointer',
                                            borderBottom: '1px solid #eee',
                                        }}
                                        onClick={() => {
                                            setPrcPartValue(item.prcpart);
                                            setPrcPart([]);
                                        }}
                                    >
                                        {item.prcpart.substring(3)}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>Qty</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={filterQty} onInput={(e) => setFilterQty(e.target.value)} />
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>Vendor Part#</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={filterVendorPart} onInput={(e) => setFilterVendorPart(e.target.value)} />
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>Dock Date</div>
                        <div className='d-flex align-items-center gap-1' style={{ width: '65%', minWidth: 0 }}>
                            <DatePicker
                                dateFormat="yyyy-MM-dd"
                                className="form-control form-control-sm"
                                id="date-start"
                                placeholderText='Start'
                                selected={startDate}
                                onChange={(e) => setStartDate(e ? e.toISOString().split('T')[0] : '')}
                            />
                            <span className="text-nowrap">-</span>
                            <DatePicker
                                dateFormat="yyyy-MM-dd"
                                className="form-control form-control-sm date-picker-no-cursor"
                                id="date-end"
                                selected={endDate}
                                placeholderText='End'
                                onChange={(e) => setEndDate(e ? e.toISOString().split('T')[0] : '')}
                            />
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>Line Tag</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={filterLineTag} onInput={(e) => setFilterLineTag(e.target.value)} />
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>PO Comment</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={filterPOComment} onInput={(e) => setFilterPOComment(e.target.value)} />
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>Notes</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={filterNotes} onInput={(e) => setFilterNotes(e.target.value)} />
                    </div>
                    <div class="col-lg-2 col-md-4 col-xs-6 pb-2 d-flex justify-content-end align-items-center">
                        <div className='px-2'>Line Status</div>
                        <input type="text" class="form-control" style={{ width: '65%' }} value={filterLineStatus} onInput={(e) => setFilterLineStatus(e.target.value)} />
                    </div>
                    <div className="col-12 d-flex justify-content-end align-items-center pt-1 pb-2">
                        <input type="button" class="btn btn-primary" value='Submit' onClick={() => fetchProduction((currentPage - 1) * itemsPerPage, itemsPerPage, statusFilter)} />
                    </div>
                </div> : ''}
            <div className='row p-2'>
                <div className="col-1 d-flex justify-content-start align-items-bottom">
                    <select
                        className="px-3 py-1 border rounded-1 d-inline"
                        value={itemsPerPage >= 999999 ? 999999 : itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="999999">All</option>
                    </select>
                </div>
                <div className="col-8">
                    <div className="btn-group d-none" role="group" aria-label="Order Status Toggle" >
                        <button
                            type="button"
                            className={`btn ${statusFilter === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => { setStatusFilter('all'); setDaysFilter(0) }}
                        >
                            All
                        </button>
                        <button
                            type="button"
                            className={`btn ${statusFilter === 'Open' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setStatusFilter('Open')}
                        >
                            Open
                        </button>
                        <button
                            type="button"
                            className={`btn ${statusFilter === 'Closed' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setStatusFilter('Closed')}
                        >
                            Closed
                        </button>

                    </div>
                    <div className='d-flex justify-content-start align-items-center ps-5' style={{ gap: '15px' }}>
                        {/* 1 Day Filter - toggle: click again to show all */}
                        <button
                            type="button"
                            className={`btn ${daysFilter === 1 ? 'btn-danger' : 'btn-outline-danger'} date-filter-btn ${daysFilter === 1 ? 'active' : ''}`}
                            onClick={() => setDaysFilter((prev) => (prev === 1 ? 0 : 1))}
                        >
                            🔥 1 Day
                        </button>
                        
                        {/* Less than a week Filter - toggle */}
                        <button
                            type="button"
                            className={`btn ${daysFilter === 2 ? 'btn-danger' : 'btn-outline-danger'} date-filter-btn ${daysFilter === 2 ? 'active' : ''}`}
                            onClick={() => setDaysFilter((prev) => (prev === 2 ? 0 : 2))}
                        >
                            🔥 less than a week
                        </button>
                        
                        {/* 1-3 weeks Filter - toggle */}
                        <button
                            type="button"
                            className={`btn date-filter-btn one-to-three-weeks ${daysFilter === 3 ? 'active' : ''}`}
                            onClick={() => setDaysFilter((prev) => (prev === 3 ? 0 : 3))}
                        >
                            ⏰ 1-3 weeks
                        </button>
                        
                        {/* 4 weeks Filter - toggle */}
                        <button
                            type="button"
                            className={`btn date-filter-btn four-weeks ${daysFilter === 4 ? 'active' : ''}`}
                            onClick={() => setDaysFilter((prev) => (prev === 4 ? 0 : 4))}
                        >
                            📆 4 weeks
                        </button>
                    </div>
                </div>

                <div className="col-3 d-flex justify-content-end align-items-center gap-2">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => setShowColumnModal(true)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            fontSize: '0.875rem',
                            padding: '6px 12px'
                        }}
                        title="Show/Hide Columns"
                    >
                        <i className="fa fa-columns" aria-hidden="true"></i>
                        Columns
                    </button>
                    <input
                        type="text"
                        className="form-control"
                        id="search"
                        placeholder={messages.search_label}
                        value={searchTerm}
                        onInput={(e) => setSearchTerm(e.target.value)}
                        onKeyDown={handleKeyDown}
                        style={{ maxWidth: '200px' }}
                    />
                </div>
            </div>
            {/* New Purchase Orders Section */}
            <div className="row mt-2" style={{ width: '98.8%', margin: '0 8px' }}>
                <div className="col-12 mb-2">
                    <div className="table-section-title">
                        <span className="table-section-text">New Purchase Orders</span>
                    </div>
                </div>
                <div className="col-12 p-0">
                    <div
                        className="overflow-auto po-order-validation-table-scroll"
                        style={{
                            width: '100%',
                            margin: 0,
                            overflowX: 'auto',
                            overflowY: 'auto',
                            maxHeight: '95vh',
                            position: 'sticky',
                            top: 0,
                            zIndex: 5,
                        }}
                    >
                        {loading ? (
                            <div className="text-center vh-50 d-flex justify-content-center align-items-center">
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <table className="table gf-table table-bordered table-hover mb-0 production-table" style={{ tableLayout: 'auto', width: '100%' }}>
                                <thead className="sticky-top bg-light" style={{ top: '0', zIndex: 10 }}>
                                    <tr>
                                        {isColumnVisible('assigned_owner') && <th className="text-center" style={{ width: 'auto', minWidth: '50px' }}>Assigned / Owner</th>}
                                        {isColumnVisible('po_verification') && <th className="text-center" style={{ width: 'auto', minWidth: '140px' }}>PO Verification</th>}
                                        {isColumnVisible('po_label') && <th className="text-center" onClick={() => handleSort('ponum')}>
                                            {messages.po_label} {getSortIcon('ponum')}
                                        </th>}
                                        {isColumnVisible('line_no') && <th className="text-center" onClick={() => handleSort('linenum')}>
                                            {messages.line_no} {getSortIcon('linenum')}
                                        </th>}
                                        {isColumnVisible('vendor_label') && <th className="text-center" onClick={() => handleSort('vendor_name')}>
                                            {messages.vendor_label} {getSortIcon('vendor_name')}
                                        </th>}
                                        {isColumnVisible('part') && <th className="text-center" onClick={() => handleSort('prcpart')}>
                                            Part# {getSortIcon('prcpart')}
                                        </th>}
                                        {isColumnVisible('qty') && <th className="text-center">QTY</th>}
                                        {isColumnVisible('vendor_part') && <th className="text-center">Vendor Part#</th>}
                                        {isColumnVisible('dock_date') && <th className="text-center" onClick={() => handleSort('duedate')} style={{ minWidth: '160px', width: '160px' }}>
                                            Dock Date {getSortIcon('duedate')}
                                        </th>}
                                        {isColumnVisible('line_tag') && <th className="text-center" style={{ minWidth: '150px', maxWidth: '200px' }}>Line Tag</th>}
                                        {isColumnVisible('comments_po') && <th className="text-center">{messages.comments_po_label}</th>}
                                        {isColumnVisible('comments') && <th className="text-center">{messages.comments_label}</th>}
                                        {isColumnVisible('line_status') && <th className="text-center line-status-column" style={{ minWidth: '450px', width: '450px', maxWidth: 'none' }}>Line Status</th>}
                                        {isColumnVisible('docs') && <th className="text-center">Docs</th>}
                                        {isColumnVisible('archive') && <th className="text-center" style={{ width: 'auto', minWidth: '50px' }}>Archive</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredNewOrdersData.length > 0 ? (
                                        filteredNewOrdersData.map((line, lineIndex) => {
                                            const dueDate = new Date(line.duedate);
                                            const today = new Date();
                                            const timeDiff = dueDate - today;
                                            const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
                                            const isReviewed = reviewToggles[line.id] || false;
                                            // Apply glow style when review toggle is ON
                                            const rowGlowStyle = isReviewed 
                                                ? { 
                                                    outline: '2px solid #22b814',
                                                    outlineOffset: '-2px',
                                                    boxShadow: '0 0 8px rgba(34, 184, 20, 0.6)',
                                                    position: 'relative',
                                                    zIndex: 1
                                                }
                                                : {};
                                            const receivedRowClass = lineHasActiveSavedReceived(line.id) ? 'po-line-row-received' : '';
                                            return (
                                                <tr 
                                                    key={`new-po-${line.po.id}-${lineIndex}`} 
                                                    className={[isReviewed ? 'review-mode-active' : '', receivedRowClass].filter(Boolean).join(' ')}
                                                    style={rowGlowStyle}
                                                >
                                                    {isColumnVisible('assigned_owner') && <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0"
                                                            title="Assign user to this purchase order"
                                                            style={{
                                                                fontSize: '1.2rem',
                                                                color: '#6c757d',
                                                                textDecoration: 'none',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                                        </button>
                                                    </td>}
                                                    {isColumnVisible('po_verification') && <td className="order-verification-column text-center">
                                                        <div className="d-flex flex-column align-items-center justify-content-center gap-3" style={{ minHeight: '60px', padding: '8px 0' }}>
                                                            {/* Review Toggle (ON/OFF switch) - Side by side */}
                                                            <div className="d-flex align-items-center gap-3 review-toggle-row">
                                                                <label className="mb-0 review-label-large">Review</label>
                                                                <label className="switch switch-medium mb-0">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={reviewToggles[line.id] || false}
                                                                        onChange={(e) => {
                                                                            const poNum = line.po?.ponum || '';
                                                                            handleReviewToggle(line.id, poNum, e.target.checked);
                                                                        }}
                                                                    />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            {/* Confirm & Move Checkbox - Label first, then checkbox */}
                                                            <div className="d-flex align-items-center gap-2">
                                                                <label htmlFor={`confirm-po-${line.id}`} className="mb-0 confirm-label-large" style={{ cursor: reviewToggles[line.id] ? 'pointer' : 'not-allowed', opacity: reviewToggles[line.id] ? 1 : 0.5 }}>
                                                                    Confirm & Move
                                                                </label>
                                                                <input
                                                                    type="checkbox"
                                                                    id={`confirm-po-${line.id}`}
                                                                    className="confirm-checkbox-large"
                                                                    checked={confirmCheckboxes[line.id] || false}
                                                                    onChange={(e) => {
                                                                        const poNum = line.po?.ponum || '';
                                                                        handleConfirmToggle(line.id, poNum, e.target.checked);
                                                                    }}
                                                                    disabled={!reviewToggles[line.id]}
                                                                    title={!reviewToggles[line.id] ? 'PO must be reviewed first before confirming' : 'Confirm and move to next step'}
                                                                    style={{ cursor: reviewToggles[line.id] ? 'pointer' : 'not-allowed', opacity: reviewToggles[line.id] ? 1 : 0.5 }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>}
                                                    {isColumnVisible('po_label') && <td className="text-center">
                                                        <div className="d-flex align-items-center justify-content-center gap-2">
                                                            <a
                                                                href={`https://gigaflightinc.cetecerp.com/purchaseorder/${line.po.id}/view`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ textDecoration: 'none' }}
                                                            >
                                                                {line.po.ponum}
                                                            </a>
                                                            {(() => {
                                                                const folderLink = line.po?.folderUrl?.trim() || null;
                                                                const folderTitle = folderLink ? `Open folder: ${folderLink}` : 'No folder link saved yet';
                                                                return (
                                                                    <a
                                                                        href={folderLink || '#'}
                                                                        onClick={(e) => { if (!folderLink) e.preventDefault(); }}
                                                                        target={folderLink ? '_blank' : undefined}
                                                                        rel={folderLink ? 'noopener noreferrer' : undefined}
                                                                        style={{ cursor: folderLink ? 'pointer' : 'not-allowed', textDecoration: 'none' }}
                                                                        title={folderTitle}
                                                                    >
                                                                        <i className="fa fa-folder" aria-hidden="true" style={{ fontSize: '16px', color: folderLink ? '#ff8c00' : '#cccccc' }}></i>
                                                                    </a>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>}
                                                    {isColumnVisible('line_no') && <td>{line.linenum}</td>}
                                                    {isColumnVisible('vendor_label') && <td className="vendor-cell">
                                                        {(line.po.vendor_id ?? line.po.vendorId) != null ? (
                                                            <a
                                                                href={`https://gigaflightinc.cetecerp.com/vendor/${line.po.vendor_id ?? line.po.vendorId}/view`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ textDecoration: 'none' }}
                                                            >
                                                                {line.po.vendorName}
                                                            </a>
                                                        ) : (
                                                            <span>{line.po.vendorName}</span>
                                                        )}
                                                    </td>}
                                                    {isColumnVisible('part') && renderPartNumberCell(line)}
                                                    {isColumnVisible('qty') && <td className="text-center">{line.orderqty || 'N/A'}</td>}
                                                    {isColumnVisible('vendor_part') && <td className="vendor-part-cell">{line.cross_part ? line.cross_part : ''}</td>}
                                                    {isColumnVisible('dock_date') && <td style={{ ...(getDueDateStyle(line.duedate) || {}), whiteSpace: 'nowrap', minWidth: '160px', width: '160px', textAlign: 'center' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                            <span>{line.duedate}</span>
                                                            <span
                                                                style={{
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    width: '32px',
                                                                    height: '32px',
                                                                    borderRadius: '50%',
                                                                    border: diffDays < 0 ? '1.5px solid #dc3545' : '1.5px solid #6c757d',
                                                                    backgroundColor: diffDays < 0 ? '#ffcccc' : 'transparent',
                                                                    color: diffDays < 0 ? '#dc3545' : '#000',
                                                                    fontWeight: 'bold',
                                                                    fontSize: '11px',
                                                                    flexShrink: 0
                                                                }}
                                                            >
                                                                {diffDays}
                                                            </span>
                                                        </div>
                                                    </td>}
                                                    {isColumnVisible('line_tag') && <td className="text-center" style={{ minWidth: '150px', maxWidth: '200px' }}>
                                                        <div className="line-tag-dropdown-container position-relative" style={{ width: '100%' }} data-line-tag-line-id={line.id}>
                                                            <div className="d-flex align-items-center gap-2" style={{ width: '100%' }}>
                                                                <div
                                                                    className="form-control d-flex align-items-start justify-content-between"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        minHeight: "38px",
                                                                        backgroundColor: "white",
                                                                        border: "1px solid #ced4da",
                                                                        width: "100%",
                                                                        maxWidth: "100%",
                                                                        overflow: "hidden",
                                                                        padding: "4px 8px"
                                                                    }}
                                                                    onClick={(e) => toggleLineTagDropdown(line.id, e)}
                                                                >
                                                                    <div className="d-flex flex-wrap gap-1" style={{ width: "100%", alignContent: "flex-start" }}>
                                                                        {/* Current selections */}
                                                                        {(lineTagSelections[line.id] || []).map((tag, index) => (
                                                                            <span
                                                                                key={`current-${index}`}
                                                                                className="badge"
                                                                                style={{
                                                                                    backgroundColor: tag.color,
                                                                                    color: "white",
                                                                                    fontSize: "0.75rem",
                                                                                    padding: "4px 8px",
                                                                                    borderRadius: "12px",
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: "4px"
                                                                                }}
                                                                            >
                                                                                {tag.label}
                                                                            </span>
                                                                        ))}

                                                                        {/* Submitted tags with click to deselect */}
                                                                        {(submittedLineTags[line.id] || []).map((tag, index) => {
                                                                            const isMarkedForDeselection = (lineTagsToDeselect[line.id] || []).some(t => t.label === tag.label);
                                                                            return (
                                                                                <span
                                                                                    key={`submitted-${index}`}
                                                                                    className="badge"
                                                                                    style={{
                                                                                        backgroundColor: isMarkedForDeselection ? "#6c757d" : tag.color,
                                                                                        color: "white",
                                                                                        fontSize: "0.75rem",
                                                                                        padding: "4px 8px",
                                                                                        borderRadius: "12px",
                                                                                        cursor: "pointer",
                                                                                        opacity: isMarkedForDeselection ? 0.6 : 1,
                                                                                        display: "inline-flex",
                                                                                        alignItems: "center",
                                                                                        gap: "4px"
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleLineTagDeselect(line.id, tag);
                                                                                    }}
                                                                                    title={isMarkedForDeselection ? "Click to keep this tag" : "Click to deselect this tag"}
                                                                                >
                                                                                    {tag.label}
                                                                                </span>
                                                                            );
                                                                        })}

                                                                        {(lineTagSelections[line.id] || []).length === 0 && (submittedLineTags[line.id] || []).length === 0 && (
                                                                            <span className="text-muted">Select tags...</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {hasLineTagChangesToSubmit(line.id) && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success btn-sm"
                                                                        style={{
                                                                            minWidth: "20px",
                                                                            height: "20px",
                                                                            padding: "0",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            fontSize: "10px",
                                                                            borderRadius: "2px"
                                                                        }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleLineTagSubmit(line.id);
                                                                        }}
                                                                        title="Submit changes"
                                                                    >
                                                                        ✓
                                                                    </button>
                                                                )}
                                                            </div>

                                                            {/* Dropdown menu - only one open at a time */}
                                                            {lineTagDropdownOpenId === line.id && lineTagDropdownPosition && (
                                                                <div
                                                                    className="position-absolute"
                                                                    style={{
                                                                        top: `${lineTagDropdownPosition.top}px`,
                                                                        left: `${lineTagDropdownPosition.left}px`,
                                                                        width: `${lineTagDropdownPosition.width}px`,
                                                                        zIndex: 1000,
                                                                        backgroundColor: 'white',
                                                                        border: '1px solid #ced4da',
                                                                        borderRadius: '4px',
                                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                                        maxHeight: '200px',
                                                                        overflowY: 'auto'
                                                                    }}
                                                                >
                                                                    {LINE_TAG_TAGS.map((tag, tagIndex) => {
                                                                        const isSelected = (lineTagSelections[line.id] || []).some(
                                                                            selection => selection.label === tag.label
                                                                        ) || (submittedLineTags[line.id] || []).some(
                                                                            selection => selection.label === tag.label
                                                                        );
                                                                        return (
                                                                            <div
                                                                                key={tagIndex}
                                                                                className="p-2 d-flex align-items-center"
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    backgroundColor: isSelected ? '#f8f9fa' : 'white',
                                                                                    borderBottom: '1px solid #f1f1f1'
                                                                                }}
                                                                                onClick={() => handleLineTagToggle(line.id, tag)}
                                                                            >
                                                                                <div
                                                                                    className="me-2"
                                                                                    style={{
                                                                                        width: '12px',
                                                                                        height: '12px',
                                                                                        borderRadius: '2px',
                                                                                        backgroundColor: tag.color
                                                                                    }}
                                                                                ></div>
                                                                                <span style={{ fontSize: '0.875rem' }}>
                                                                                    {tag.label}
                                                                                </span>
                                                                                {isSelected && (
                                                                                    <span className="ms-auto">✓</span>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>}
                                                    {isColumnVisible('comments_po') && <td className="shipping-comments-cell">
                                                        <div className="shipping-comments-content">
                                                            {line.po.comment ? line.po.comment : ''}
                                                        </div>
                                                    </td>}
                                                    {isColumnVisible('comments') && <td>
                                                        {(line.comment || commentsMap[line.id]?.length) ? (
                                                            <div className="d-flex align-items-start gap-2">
                                                                <textarea style={{ width: '180px' }}
                                                                    value={
                                                                        (() => {
                                                                            const merged = [...(line.comment || []), ...(commentsMap[line.id] || [])];
                                                                            const last = merged.length ? merged[merged.length - 1] : null;
                                                                            return last?.comment || '';
                                                                        })()
                                                                    }
                                                                    className="form-control"
                                                                    rows={1}
                                                                />
                                                                <Hover
                                                                    orderLineId={line.id}
                                                                    comments={[...(line.comment || []), ...(commentsMap[line.id] || [])]}
                                                                    orderNumber={line.po?.ponum}
                                                                    customerName={line.po?.vendorName}
                                                                    lineInfo={line.linenum != null ? `Line ${line.linenum}` : undefined}
                                                                    sourcePage="purchase"
                                                                    onAddComment={(newComment, status) => handleAddComment(line.id, newComment, status)}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-light"
                                                                        style={{ padding: "6px", borderRadius: "50%", border: "1px solid #ccc" }}
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 512 512">
                                                                            <path
                                                                                fill="currentColor"
                                                                                d="M344 0L488 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512L24 512c-13.3 0-24-10.7-24-24L0 344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
                                                                            />
                                                                        </svg>
                                                                    </button>
                                                                </Hover>
                                                            </div>
                                                        ) : (
                                                            <textarea className="form-control" rows={1} />
                                                        )}
                                                    </td>}
                                                    {isColumnVisible('line_status') && <td className="text-center line-status-column" style={{ minWidth: '450px', width: '450px', maxWidth: 'none' }}>
                                                        <div className="line-status-dropdown-container position-relative" style={{ width: '100%' }} data-line-status-line-id={line.id}>
                                                            <div className="d-flex align-items-center gap-2" style={{ width: '100%' }}>
                                                                <div
                                                                    className="form-control d-flex align-items-start justify-content-between"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        minHeight: "60px",
                                                                        backgroundColor: "white",
                                                                        border: "1px solid #ced4da",
                                                                        width: "100%",
                                                                        maxWidth: "100%",
                                                                        overflow: "visible",
                                                                        padding: "8px 12px"
                                                                    }}
                                                                    onClick={(e) => toggleLineStatusDropdown(line.id, e)}
                                                                >
                                                                    <div className="d-flex flex-wrap gap-2" style={{ width: "100%", alignContent: "flex-start" }}>
                                                                        {/* Current selections */}
                                                                        {(lineStatusSelections[line.id] || []).map((tag, index) => (
                                                                            <span
                                                                                key={`current-status-${index}`}
                                                                                className="badge"
                                                                                style={{
                                                                                    backgroundColor: tag.color,
                                                                                    color: "white",
                                                                                    fontSize: "1rem",
                                                                                    padding: "8px 14px",
                                                                                    borderRadius: "16px",
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: "6px",
                                                                                    fontWeight: "500",
                                                                                    lineHeight: "1.4"
                                                                                }}
                                                                            >
                                                                                {tag.label}
                                                                            </span>
                                                                        ))}

                                                                        {/* Submitted tags with click to deselect */}
                                                                        {(submittedLineStatuses[line.id] || []).map((tag, index) => {
                                                                            const isMarkedForDeselection = (lineStatusTagsToDeselect[line.id] || []).some(t => t.label === tag.label);
                                                                            return (
                                                                                <span
                                                                                    key={`submitted-status-${index}`}
                                                                                    className="badge"
                                                                                    style={{
                                                                                        backgroundColor: isMarkedForDeselection ? "#6c757d" : tag.color,
                                                                                        color: "white",
                                                                                        fontSize: "1rem",
                                                                                        padding: "8px 14px",
                                                                                        borderRadius: "16px",
                                                                                        cursor: "pointer",
                                                                                        opacity: isMarkedForDeselection ? 0.6 : 1,
                                                                                        display: "inline-flex",
                                                                                        alignItems: "center",
                                                                                        gap: "6px",
                                                                                        fontWeight: "500",
                                                                                        lineHeight: "1.4"
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleLineStatusDeselect(line.id, tag);
                                                                                    }}
                                                                                    title={isMarkedForDeselection ? "Click to keep this tag" : "Click to deselect this tag"}
                                                                                >
                                                                                    {tag.label}
                                                                                </span>
                                                                            );
                                                                        })}

                                                                        {(lineStatusSelections[line.id] || []).length === 0 && (submittedLineStatuses[line.id] || []).length === 0 && (
                                                                            <span className="text-muted" style={{ fontSize: "1rem", padding: "8px 0" }}>Select tags...</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {hasLineStatusChangesToSubmit(line.id) && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success btn-sm"
                                                                        style={{
                                                                            minWidth: "20px",
                                                                            height: "20px",
                                                                            padding: "0",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            fontSize: "10px",
                                                                            borderRadius: "2px"
                                                                        }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleLineStatusSubmit(line.id);
                                                                        }}
                                                                        title="Submit changes"
                                                                    >
                                                                        ✓
                                                                    </button>
                                                                )}
                                                            </div>

                                                            {/* Dropdown menu - only one open at a time */}
                                                            {lineStatusDropdownOpenId === line.id && lineStatusDropdownPosition && (
                                                                <div
                                                                    className="position-absolute"
                                                                    style={{
                                                                        top: `${lineStatusDropdownPosition.top}px`,
                                                                        left: `${lineStatusDropdownPosition.left}px`,
                                                                        width: `${lineStatusDropdownPosition.width}px`,
                                                                        zIndex: 1000,
                                                                        backgroundColor: 'white',
                                                                        border: '1px solid #ced4da',
                                                                        borderRadius: '4px',
                                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                                        maxHeight: '200px',
                                                                        overflowY: 'auto'
                                                                    }}
                                                                >
                                                                    {LINE_STATUS_TAGS.map((tag, tagIndex) => {
                                                                        const isSelected = (lineStatusSelections[line.id] || []).some(
                                                                            selection => selection.label === tag.label
                                                                        ) || (submittedLineStatuses[line.id] || []).some(
                                                                            selection => selection.label === tag.label
                                                                        );
                                                                        return (
                                                                            <div
                                                                                key={tagIndex}
                                                                                className="p-2 d-flex align-items-center"
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    backgroundColor: isSelected ? '#f8f9fa' : 'white',
                                                                                    borderBottom: '1px solid #f1f1f1'
                                                                                }}
                                                                                onClick={() => handleLineStatusToggle(line.id, tag)}
                                                                            >
                                                                                <div
                                                                                    className="me-2"
                                                                                    style={{
                                                                                        width: '12px',
                                                                                        height: '12px',
                                                                                        borderRadius: '2px',
                                                                                        backgroundColor: tag.color
                                                                                    }}
                                                                                ></div>
                                                                                <span style={{ fontSize: '0.875rem' }}>
                                                                                    {tag.label}
                                                                                </span>
                                                                                {isSelected && (
                                                                                    <span className="ms-auto">✓</span>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>}
                                                    {isColumnVisible('docs') && <td className="text-center">
                                                        <div className="d-flex align-items-center justify-content-center flex-wrap gap-1" style={{ maxWidth: '220px', margin: '0 auto' }}>
                                                            {(docsLinks[line.id] || []).map((link) => (
                                                                <a
                                                                    key={link.id}
                                                                    href={link.url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-primary btn-sm"
                                                                    style={{ fontSize: '0.875rem', padding: '6px 14px', textDecoration: 'none', minWidth: '72px' }}
                                                                    title={`Open folder: ${link.url}`}
                                                                >
                                                                    Folder
                                                                </a>
                                                            ))}
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-secondary"
                                                                style={{ fontSize: '0.875rem', padding: '5px 10px' }}
                                                                onClick={() => handleDocsClick(line)}
                                                                title="Add folder / doc links"
                                                            >
                                                                <i className="fa fa-plus" style={{ marginRight: '4px' }}></i>
                                                                Add
                                                            </button>
                                                        </div>
                                                    </td>}
                                                    {isColumnVisible('archive') && <td className="text-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-0"
                                                            onClick={() => handleArchiveOrder(line)}
                                                            title="Archive this PO line"
                                                            style={{
                                                                fontSize: '1.2rem',
                                                                color: '#6c757d',
                                                                textDecoration: 'none'
                                                            }}
                                                        >
                                                            <i className="fa fa-paper-plane" aria-hidden="true"></i>
                                                        </button>
                                                    </td>}
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={poOrderValidationColumns.filter(col => isColumnVisible(col.key)).length} className="text-center">No new purchase orders available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
                <div className="col-12 py-2">
                    <nav aria-label="Page navigation example">
                        <span>
                            Showing {totalRecords} of {displayTotalRecords}
                        </span>

                        <ul className="pagination float-end align-items-center mb-0">
                            {/* Previous Button */}
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                                    Previous
                                </button>
                            </li>

                            {/* Page Select Dropdown Styled Like Pagination */}
                            <li className="page-item">
                                <select
                                    className="form-select mx-2"
                                    style={{ width: 'auto' }}
                                    value={currentPage}
                                    onChange={(e) => handlePageChange(Number(e.target.value))}
                                >
                                    {[...Array(totalPages)].map((_, index) => (
                                        <option key={index} value={index + 1}>
                                            Page {index + 1}
                                        </option>
                                    ))}
                                </select>
                            </li>

                            {/* Next Button */}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Label>Comment:</Form.Label>
                            <Form.Control
                                type="text"
                                name="comment"
                                value={formData ? formData.comment : ''}
                                onChange={handleChange}
                                placeholder="Enter comment"
                            />
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label>Flow Name:</Form.Label>
                            <Form.Control
                                type="text"
                                name="flowName"
                                value={"Order"}
                                onChange={handleChange}
                                disabled={true}
                                placeholder="Enter flow name"
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mt-3">
                            <Form.Label>PO Status:</Form.Label>
                            <Form.Select
                                name="poStatus"
                                onChange={handleChange}
                            >
                            <option value="Open" selected={updatePopUp.status === 'Open'}>Open</option>
                            <option value="Closed" selected={updatePopUp.status === 'Closed'}>Closed</option>
                                   
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mt-3">
                            <Form.Label>Status:</Form.Label>
                            <Form.Select
                                name="status"
                                onChange={handleChange}
                                required
                            >
                                {formData ? (
                                    <>
                                        <option value="Can ship early" style={{ color: 'green' }} selected={formData.status === "Can ship early"}>Can ship early</option>
                                        <option value="Do not ship early" style={{ color: '#F8D700' }} selected={formData.status === "Do not ship early"}>Do not ship early</option>
                                        <option value="CC hold" style={{ color: 'orange' }} selected={formData.status === "CC hold"}>CC hold</option>
                                        <option value="Wire hold" style={{ color: '#8B47FF' }} selected={formData.status === "Wire hold"}>Wire hold</option>
                                        <option value="Credit hold" style={{ color: 'red' }} selected={formData.status === "Credit hold"}>Credit hold</option>
                                    </>
                                ) : (
                                    <>
                                        <option value="Can ship early" style={{ color: 'green' }}>Can ship early</option>
                                        <option value="Do not ship early" style={{ color: '#F8D700' }}>Do not ship early</option>
                                        <option value="CC hold" style={{ color: 'orange' }}>CC hold</option>
                                        <option value="Wire hold" style={{ color: '#8B47FF' }}>Wire hold</option>
                                        <option value="Credit hold" style={{ color: 'red' }}>Credit hold</option>
                                    </>
                                )}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mt-3">
                            <Form.Label>Order Line ID:</Form.Label>
                            <Form.Control
                                type="number"
                                name="orderLineId"
                                value={updatePopUp.id}
                                disabled={true}
                                onChange={handleChange}
                                placeholder="Enter Order Line ID"
                                required
                            />
                        </Form.Group>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            <Button variant="primary" type="submit">
                                Save Changes
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Docs - Add Folder Links Modal */}
            <Modal show={showDocsModal} onHide={handleCloseDocsModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Docs – Add Folder Links</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedLineForDocs && (
                        <div>
                            <div className="mb-3">
                                <p className="mb-0"><strong>PO:</strong> {selectedLineForDocs.po?.ponum ?? 'N/A'} &nbsp;|&nbsp; <strong>Line#:</strong> {selectedLineForDocs.linenum ?? 'N/A'}</p>
                            </div>
                            <div className="mt-3">
                                <h6>Existing folder links:</h6>
                                <div className="d-flex flex-wrap gap-2 mb-3">
                                    {(docsLinks[selectedLineForDocs.id] || []).map((link) => (
                                        <div key={link.id} className="d-flex align-items-center gap-1">
                                            <a
                                                href={link.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-sm btn-outline-primary"
                                                style={{ fontSize: '0.75rem' }}
                                                title={`Open: ${link.url}`}
                                            >
                                                Folder
                                            </a>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger"
                                                style={{ padding: '2px 6px' }}
                                                onClick={() => handleDeleteDocsLink(selectedLineForDocs.id, link.id)}
                                                title="Delete link"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                    {(docsLinks[selectedLineForDocs.id] || []).length === 0 && (
                                        <p className="text-muted mb-0">No folder links added yet.</p>
                                    )}
                                </div>
                            </div>
                            <div className="mt-3">
                                <Form.Label><strong>Add new folder link:</strong></Form.Label>
                                <div className="d-flex gap-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter folder URL (e.g. https://...)"
                                        value={newDocsLinkUrl}
                                        onChange={(e) => setNewDocsLinkUrl(e.target.value)}
                                    />
                                    <Button variant="primary" onClick={handleAddDocsLink}>Add</Button>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDocsModal}>Close</Button>
                </Modal.Footer>
            </Modal>

            {/* Column Visibility Modal */}
            <ColumnVisibilityModal
                show={showColumnModal}
                onHide={() => setShowColumnModal(false)}
                columns={poOrderValidationColumns}
                visibleColumns={columnVisibility}
                onColumnVisibilityChange={handleColumnVisibilityChange}
                pageName="poOrderValidation"
            />
        </div>
    );
};



export default PoOrderValidation;
